export default __webpack_public_path__ + "static/media/opera.b6559658.svg";